export const chunk = (target, chunkLength) => {
    let tempArray = [];

    for (let i = 0, j = target.length; i < j; i += chunkLength) {
        tempArray.push(target.slice(i, i + chunkLength));
    }

    return tempArray;
};

export const wait = (time) => {
    return new Promise((r) => setTimeout(r, time));
};

export const pxToRem = (px) => {
    return px / parseFloat(getComputedStyle(document.documentElement).fontSize) + 'rem';
};

export const isAccessibleElement = (target) => {
    const tags = 'a input textarea button select'.split(' ');

    const parents = tags.every((el) => $(target).closest(el).length <= 0);
    const self = tags.every((el) => target.tagName.toLowerCase() !== el);

    return parents && self;
};

//Returns true if it is a DOM node
export const isNode = (o) => {
    return (
        typeof Node === "object" ? o instanceof Node :
            o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName === "string"
    );
};

//Returns true if it is a DOM element
export const isElement = (o) => {
    return (
        typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
            o && typeof o === "object" && o.nodeType === 1 && typeof o.nodeName === "string"
    );
};

export const getjQueryEl = (el) => {
    var $el;

    if (el instanceof jQuery) {
        $el = el;
    } else if (typeof el === 'string') {
        $el = $(el);
    } else if (isElement(el)) {
        $el = $(el);
    } else {
        $el = el;
    }

    return $el;
};

export const getFormatZero = (v) => v < 10 ? '0'+v : v;
